<template>
    <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    {{ $t("require-text.title") }}
                </p>
            </header>
            <section class="modal-card-body">
                <div class="field">
                    <label class="label">{{ action.title }}:</label>
                    <div class="control">
                        <input type="text" class="input" v-model="answer" />
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot is-justify-content-flex-end">
                <button class="button" @click="save">
                    <Icon
                        name="fa-paper-plane"
                        helperClass="has-text-primary"
                    />
                    <span> {{ $t("require-text.send") }}</span>
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
    name: "require-text",
    props: {
        action: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            answer: "",
        };
    },
    computed: {
        ...mapGetters("conference", ["getConferenceId"]),
    },
    methods: {
        ...mapActions("actions", ["setActionAnswer"]),
        save() {
            let actionResult = this.action;
            actionResult.answer = this.answer;
            this.setActionAnswer(actionResult);
            let roomId = this.getConferenceId;
            this.$emit("answered", {
                socketName: "SendTextActionAnswer",
                roomId: roomId,
                actionId: this.action.id,
                answer: this.answer,
                type: this.action.type
            });
            this.answer = ''
        },
    },
};
</script>